// Unpublished Work © 2021-2026 Deere & Company.

import {combineReducers} from 'redux';
import {reducerTcombWrapper} from '@deere/cap-it-ui.redux-store-creator';
import {contacts} from './contacts';
import {customer} from './customer';
import {equipmentDetails} from './equipment-details';
import {crossReferences} from './cross-references';
import {logHistory} from './log-history';
import {status as pageStatus} from './status';
import {removeVisibilityError} from './removeVisibility-error';
import {CustomerProfile} from '../../state/struct/profile';
import {isCustomerVisibilityRemoved} from './customer-visibility-remove-status';
import {deleteContactReducer} from './delete-contact';
import {mergeContactReducer} from './merge-contact';

export const getCustomerProfileCombinedReducer = () => {
    const combinedReducer = combineReducers({
        contacts,
        crossReferences,
        customer,
        deleteBusinessContacts: deleteContactReducer,
        equipmentDetails,
        logHistory,
        pageStatus,
        removeVisibilityError,
        isCustomerVisibilityRemoved,
        mergeBusinessContacts: mergeContactReducer
    });

    return reducerTcombWrapper.bind(
        this,
        {
            combinedReducer,
            stateStruct: CustomerProfile
        }
    );
};
